import { render, staticRenderFns } from "./ChatExtensionOnboarding.vue?vue&type=template&id=7d270894&scoped=true"
import script from "./ChatExtensionOnboarding.vue?vue&type=script&lang=js"
export * from "./ChatExtensionOnboarding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d270894",
  null
  
)

export default component.exports